import React from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import RelatedGames from "../web-games/related-games";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function SingleArea() {
  const { id } = useParams();

  // useEffect(() => {
  //   if (id === "68d63a4dd93dae5f7547f0df") {
  //     window.location.href = "https://obigin.com/details/formulaspeed";
  //   }
  // }, [id]);

  const {
    data: game,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["game-details", id],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/games/${id}`
      );
      return data.data;
    },
    enabled: !!id,
  });

  if (isLoading) return <p>Loading game details...</p>;
  if (isError || !game) return <p>Game not found or error occurred.</p>;

  return (
    <React.Fragment>
      <section className="breadcrumb-area breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-content text-center">
                <h2>
                  Game <span>Details</span>
                </h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      {" "}
                     <Link to={game.type === "web" ? "/web-games" : "/downloadable-games"}>
                      {game.type === "web" ? "Web Games" : "Downloadable Games"}
                     </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {" "}
                      {game.name}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="game-single-area pt-120 pb-40">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="game-single-content">
                <div className="upcoming-game-head">
                  <div className="uc-game-head-title single-area-header">
                    <div>
                      <h1 className="text-red">{game.name}</h1>
                      {game.featured && <span>🔥 Featured</span>}
                    </div>
                    <div>
                      {game.type == "downloadable" && (
                        <a href={game.link} target="_blank" rel="noreferrer">
                          <img
                            style={{
                              height: "40px",
                              marginLeft: "10px",
                              marginBottom: "5px",
                            }}
                            src="/assets/img/images/google-play.jpg"
                            alt={game.name}
                          />
                        </a>
                      )}
                      <div className="uc-game-price">
                        <a href={game.link || "#"} target="_blank" rel="noreferrer">
                          <h5>{game.status === "live" ? "Play Now" : game.status}</h5>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p>{game.longDescription || game.shortDescription}</p>

                <div className="game-single-img mt-4 mb-4">
                  <div className="row">
                    <div className="col-sm-6">
                      <img
                        src={
                          game.graphic ||
                          "/assets/img/images/game_single_img01.jpg"
                        }
                        alt={game.name}
                      />
                    </div>
                    {game.vertical_graphic && (
                      <div className="col-sm-6">
                        <img
                          src={
                            game.vertical_graphic
                          }
                          alt={game.name}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="game-single-title mt-60 ">
                  <h4>
                    Game <span>Details</span>
                  </h4>
                </div>
                <div className="game-single-info mb-65">
                  <ul>
                    <li>
                      <span>Name:</span> {game.name}
                    </li>
                    <li>
                      <span>Status:</span> {game.status}
                    </li>
                    <li>
                      <span>Featured:</span> {game.featured ? "Yes" : "No"}
                    </li>
                    <li>
                      <span>Type:</span> {game.type}
                    </li>
                    <li>
                      <span>Age Rating:</span> {game.ageRating}
                    </li>
                    <li>
                      <span>Multiplayer:</span>{" "}
                      {game.isMultiplayer ? "Yes" : "No"}
                    </li>
                    <li>
                      <span>Platform:</span> {game.platform.join(", ")}
                    </li>
                    <li>
                      <span>Genre:</span> {game.genre.join(", ")}
                    </li>
                    <li>
                      <span>Orientation:</span> {game.orientation || "N/A"}
                    </li>
                    <li>
                      <span>Server Type:</span> {game.serverType || "N/A"}
                    </li>
                    <li>
                      <span>Created At:</span>{" "}
                      {new Date(game.createdAt).toLocaleString()}
                    </li>
                    <li>
                      <span>Updated At:</span>{" "}
                      {new Date(game.updatedAt).toLocaleString()}
                    </li>
                    {game.link && (
                      <li>
                        <span>Link:</span>{" "}
                        <a
                          href={game.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {game.type == "web" ? "PLAY GAME" : "Visit Game"}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>

                <div className="game-single-shape">
                  <img
                    src="/assets/img/images/game_section_shape.png"
                    alt="shape"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="game-single-title pt-40">
            <h4>
              Related <span>Games</span>
            </h4>
          </div>
          <RelatedGames type={game.genre[0]} id={id} />
        </div>
      </section>
    </React.Fragment>
  );
}

export default SingleArea;
